import React from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';

import { useStore } from 'core/store';
import useStyles from './purchased-offer-banner.styles';

/**
 * Warns staff when the offer they opened has already been committed to a policy, so it
 * isn't submitted for review or bound a second time (GitHub issue #31622). The bound
 * policy is looked up by the offer store when the offer loads (fetchBoundPolicy).
 */
const PurchasedOfferBanner = observer(() => {
  const classes = useStyles();
  const {
    offer: { boundPolicy }
  } = useStore();

  if (!boundPolicy) {
    return null;
  }

  return (
    <div className={classes.banner} role="alert">
      <span>
        {`This offer has already been purchased — policy ${boundPolicy.id} is on file. Submitting it for review or binding it again would create a duplicate policy.`}
      </span>
      <Link className={classes.link} to={`/customer/${boundPolicy.accountId}/policy/${boundPolicy.id}`}>
        View policy
      </Link>
    </div>
  );
});

export default PurchasedOfferBanner;
